import generalSection from "./general";
import homeownersSection from "./homeowners";
import hybridCompaniesSection from "./hybrid-companies";
import installersAndEPCsSection from "./installers-and-epcs";
import integrationPartnersSection from "./integration-partners";
import masterDealersSection from "./master-dealers";
import platformFeaturesSection from "./platform-features";
import pricingSection from "./pricing-and-contract";
import salesDealersSection from "./sales-dealers";
import type { FaqSection } from "./types";

export const faqData: FaqSection[] = [
  generalSection,
  salesDealersSection,
  masterDealersSection,
  installersAndEPCsSection,
  hybridCompaniesSection,
  platformFeaturesSection,
  pricingSection,
  integrationPartnersSection,
  homeownersSection,
];
